module.exports = __webpack_public_path__ + "static/img/Bachelor_010481.a18465e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010481.jpg
// module id = 174
// module chunks = 0